import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import ApiServices from "../../../Utils/ApiServices/ApiServices";
import { getDecryptedAccessToken } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";

const roles = ["Head", "Lead", "Employee", "Other"];

const AssignDepartmentDialog = ({ open, onClose, userId, onAssigned }) => {
  const token = getDecryptedAccessToken();

  const [departments, setDepartments] = useState([]);
  const [form, setForm] = useState({
    department: "",
    position_in_dept: "",
    is_primary: false,
  });

  useEffect(() => {
    const fetchDepartments = async () => {
      const res = await ApiServices.get("/api/v1/admin/departments/", {
        Authorization: `Bearer ${token}`,
      });

      setDepartments(res?.data?.results || []);
    };

    if (open) fetchDepartments();
  }, [open]);

  const handleSubmit = async () => {
    await ApiServices.post(
      `/api/v1/admin/users/${userId}/assign-department/`,
      form,
      { Authorization: `Bearer ${token}` },
    );

    onAssigned();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Assign Department</DialogTitle>

      <DialogContent>
        <TextField
          select
          label="Department"
          fullWidth
          margin="normal"
          value={form.department}
          onChange={(e) => setForm({ ...form, department: e.target.value })}
        >
          {departments.map((d) => (
            <MenuItem key={d.id} value={d.id}>
              {d.title}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          select
          label="Position"
          fullWidth
          margin="normal"
          value={form.position_in_dept}
          onChange={(e) =>
            setForm({ ...form, position_in_dept: e.target.value })
          }
        >
          {roles.map((r) => (
            <MenuItem key={r} value={r}>
              {r}
            </MenuItem>
          ))}
        </TextField>

        <FormControlLabel
          control={
            <Checkbox
              checked={form.is_primary}
              onChange={(e) =>
                setForm({ ...form, is_primary: e.target.checked })
              }
            />
          }
          label="Primary Department"
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>

        <Button variant="contained" onClick={handleSubmit}>
          Assign
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignDepartmentDialog;
